export const enumOriginType = {
  FLEXI_COMBO_ADD: 'flexiComboAdd',
  FLEXI_COMBO_EDIT: 'flexiComboEdit',
  ADD_PRODUCT_MANUAL: 'addProductManual',
  PWP: 'pwp',
  GWP: 'gwp',
}
